import { render, staticRenderFns } from "./home-carousel.vue?vue&type=template&id=13714537&scoped=true"
import script from "./home-carousel.vue?vue&type=script&lang=js"
export * from "./home-carousel.vue?vue&type=script&lang=js"
import style0 from "./home-carousel.vue?vue&type=style&index=0&id=13714537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13714537",
  null
  
)

export default component.exports